<template>
  <v-container fluid>
    <form action @submit.prevent="submitForm">
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="success" v-if="success">
        <p>{{ success }}</p>
      </div>

      <div class="feedback-info">
        <p>
          {{ $t("app.feedback.allFeedback") }}
        </p>
      </div>

      <div class="field">
        <InputField
          v-model="form.subject"
          :labelTitle="$t('app.feedback.form-subject')"
          required
          :placeholder="$t('app.feedback.feedbackSubjectPlaceholder')"
          margin="25px auto"
        ></InputField>

        <TextAreaField
          v-model="form.description"
          required
          :labelTitle="$t('app.feedback.form-description')"
          :placeholder="$t('app.feedback.feedbackDescriptionPlaceholder')"
          margin="0 auto 25px auto"
        ></TextAreaField>

        <div class="consent-checkbox">
          <label for="contactConsent" class="checkbox-container">
            {{ $t("app.feedback.contact-consent-feedback") }}
            <input
              type="checkbox"
              id="contactConsent"
              v-model="form.contactConsent"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <LoadingButton v-if="loading" margin="0 auto 25px auto"></LoadingButton>
        <Button
          v-else
          type="submit"
          :title="$t('app.feedback.action-send')"
          margin="0 auto 25px auto"
        ></Button>
      </div></form
  ></v-container>
</template>

<script>
import { neoparentFeedback } from "@/api";

export default {
  name: "neoparent-feedback",
  data() {
    return {
      success: "",
      error: "",
      form: {
        category: "",
        subject: "",
        description: "",
        contactConsent: false
      },
      loading: false
    };
  },
  mounted() {},
  methods: {
    submitForm() {
      if (confirm(this.$t("app.feedback.confirm"))) {
        this.loading = true;

        const data = {
          subject: this.form.subject,
          description: this.form.description,
          contactConsent: this.form.contactConsent
        };

        neoparentFeedback
          .sendFeedback(data)
          .then(result => {
            this.consoleLog(result);
            this.consoleLog("Email sent");
            this.success = this.$t("success.feedback-sent");
            this.error = "";
            window.scrollTo(0, 0);
            this.loading = false;
          })
          .catch(err => {
            this.consoleLog(err);
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
